import React from "react";
import { Button, withStyles } from "@material-ui/core";
import { dataToExcelXlsx } from "../utility/files";

const CustomButton = withStyles({
  root: {
    minWidth: 28,
    height: 24,
    padding: 0,
    marginLeft: "auto",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
})(Button);

interface Props<D> {
  data: D[];
  headers: string[][];
  filename?: string;
  matchesMediaQuery: boolean;
}

const ExportExcel = <D extends object>(props: Props<D>) => {
  const { data = [], headers, filename, matchesMediaQuery } = props;

  return (
    <div style={{ display: "flex" }}>
      <CustomButton
        style={{
          marginRight: matchesMediaQuery ? "16px" : "0",
        }}
        onClick={() => {
          dataToExcelXlsx(data, headers, filename);
        }}
      >
        <svg
          className="export-excel-icon"
          width="28"
          height="24"
          viewBox="0 0 28 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 7.5L12.5 7.5L12.5 3.5L13.5 3.5L16.5 6.5L16.5 9M11 3.5L5.5 3.5L5.5 11M5.5 16L5.5 20L16.5 20L16.5 18"
            stroke="#8E8E8E"
          />
          <path
            className="extension"
            d="M11.3594 15.1172C11.3594 15.25 11.3112 15.3646 11.2148 15.4609C11.1185 15.5573 11.0039 15.6055 10.8711 15.6055C10.7435 15.6055 10.6315 15.5586 10.5352 15.4648C10.4388 15.3711 10.3906 15.2578 10.3906 15.125C10.3906 14.9792 10.4388 14.862 10.5352 14.7734C10.6315 14.6823 10.7435 14.6367 10.8711 14.6367C10.9987 14.6367 11.112 14.6836 11.2109 14.7773C11.3099 14.8685 11.3594 14.9818 11.3594 15.1172ZM14.7422 11.9062H15.6523L14.1719 13.6758L15.7578 15.5H14.8477L13.7188 14.2109L12.6523 15.5H11.7578L13.2695 13.6758L11.7578 11.9062H12.6523L13.7188 13.1406L14.7422 11.9062ZM16.2773 15.5V10.043H16.9883V15.5H16.2773ZM19.0117 11.8359C19.3789 11.8359 19.7422 11.9349 20.1016 12.1328V12.8438C19.8828 12.7109 19.6927 12.6146 19.5312 12.5547C19.3724 12.4922 19.2148 12.4609 19.0586 12.4609C18.9049 12.4609 18.7904 12.4883 18.7148 12.543C18.6419 12.5951 18.6055 12.6576 18.6055 12.7305C18.6055 12.8008 18.6198 12.8607 18.6484 12.9102C18.6771 12.957 18.7422 13.0182 18.8438 13.0938C18.9453 13.1667 19.1029 13.2643 19.3164 13.3867C19.6081 13.5586 19.8411 13.7305 20.0156 13.9023C20.1901 14.0716 20.2773 14.2865 20.2773 14.5469C20.2773 14.7031 20.2357 14.8607 20.1523 15.0195C20.069 15.1758 19.9336 15.3073 19.7461 15.4141C19.5612 15.5182 19.3268 15.5703 19.043 15.5703C18.8398 15.5703 18.6536 15.5482 18.4844 15.5039C18.3177 15.4596 18.1042 15.3724 17.8438 15.2422V14.4766C18.0156 14.6094 18.207 14.7214 18.418 14.8125C18.6315 14.9036 18.8216 14.9492 18.9883 14.9492C19.1758 14.9492 19.3138 14.918 19.4023 14.8555C19.4935 14.7904 19.5391 14.7096 19.5391 14.6133C19.5391 14.5326 19.5221 14.4661 19.4883 14.4141C19.4544 14.3594 19.3789 14.293 19.2617 14.2148C19.1471 14.1341 18.9544 14.013 18.6836 13.8516C18.418 13.6875 18.2148 13.5247 18.0742 13.3633C17.9362 13.1992 17.8672 13.0026 17.8672 12.7734C17.8672 12.5 17.9753 12.276 18.1914 12.1016C18.4076 11.9245 18.681 11.8359 19.0117 11.8359ZM23.5781 11.9062H24.4883L23.0078 13.6758L24.5938 15.5H23.6836L22.5547 14.2109L21.4883 15.5H20.5938L22.1055 13.6758L20.5938 11.9062H21.4883L22.5547 13.1406L23.5781 11.9062Z"
            fill="#444443"
          />
          <path
            className="arrow"
            d="M2 13.5L8 13.5M8 13.5L6.5 12M8 13.5L6.5 15"
            stroke="#8E8E8E"
          />
        </svg>
      </CustomButton>
    </div>
  );
};

export default React.memo(ExportExcel);
